/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Mám jinou žádost.`
};

const da_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Jeg har en anden forespørgsel.`
};

const de_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Ich habe eine andere Anfrage.`
};

const en_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `I have another request.`
};

const es_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Tengo otra consulta.`
};

const fr_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `J'ai une autre demande.`
};

const hu_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Más kérésem van.`
};

const it_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Ho un'altra richiesta.`
};

const nl_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Ik heb een andere vraag.`
};

const pl_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Inne zapytanie.`
};

const pt_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Tenho outro pedido.`
};

const sv_contact_subjects_other = /** @type {(inputs: {}) => string} */ () => {
	return `Jag har en annan fråga.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_subjects_other = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_subjects_other(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_subjects_other", locale)
	if (locale === "cs") return cs_contact_subjects_other(inputs)
	if (locale === "da") return da_contact_subjects_other(inputs)
	if (locale === "de") return de_contact_subjects_other(inputs)
	if (locale === "en") return en_contact_subjects_other(inputs)
	if (locale === "es") return es_contact_subjects_other(inputs)
	if (locale === "fr") return fr_contact_subjects_other(inputs)
	if (locale === "hu") return hu_contact_subjects_other(inputs)
	if (locale === "it") return it_contact_subjects_other(inputs)
	if (locale === "nl") return nl_contact_subjects_other(inputs)
	if (locale === "pl") return pl_contact_subjects_other(inputs)
	if (locale === "pt") return pt_contact_subjects_other(inputs)
	return sv_contact_subjects_other(inputs)
};
export { contact_subjects_other as "contact.subjects.other" }